import React from "react";
import { motion } from "framer-motion";

/**
 * SectionDivider — animated horizontal scanning line that pulses on scroll-into-view.
 * Use between major sections.
 */
export const SectionDivider = ({ className = "" }) => {
  return (
    <div className={`relative w-full h-px ${className}`} data-testid="section-divider">
      <motion.div
        initial={{ scaleX: 0, opacity: 0 }}
        whileInView={{ scaleX: 1, opacity: 1 }}
        viewport={{ once: true, margin: "-20%" }}
        transition={{ duration: 1.2, ease: "easeOut" }}
        className="absolute inset-0 origin-left"
        style={{
          background:
            "linear-gradient(90deg, transparent 0%, rgba(123,47,190,0.5) 30%, rgba(45,212,191,0.5) 70%, transparent 100%)",
        }}
      />
      {/* travelling pulse */}
      <motion.div
        initial={{ x: "-20%", opacity: 0 }}
        whileInView={{ x: "120%", opacity: [0, 1, 0] }}
        viewport={{ once: true, margin: "-20%" }}
        transition={{ duration: 1.6, ease: "easeInOut", delay: 0.2 }}
        className="absolute top-1/2 -translate-y-1/2 h-[2px] w-[120px]"
        style={{
          background:
            "linear-gradient(90deg, transparent, #2DD4BF, #7B2FBE, transparent)",
          boxShadow: "0 0 14px rgba(45,212,191,0.8)",
        }}
      />
    </div>
  );
};

export default SectionDivider;
